import { useState } from "react"
import { motion, AnimatePresence } from "framer-motion"
import "./InfoPanel.css"

function InfoPanel({ title, tabs, renderTab }) {
  const [activeTab, setActiveTab] = useState(tabs[0].key)

  return (
    <div className="info-panel">
      <div className="info-header">
        <h2>{title}</h2>
      </div>

      <div className="info-tabs">
        {tabs.map((tab) => (
          <button
            key={tab.key}
            className={`info-tab ${activeTab === tab.key ? "active" : ""}`}
            onClick={() => setActiveTab(tab.key)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div className="info-panel-body">
        <AnimatePresence mode="wait">
          <motion.div
            key={activeTab}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.3 }}
            className="info-tab-pane"
          >
            {renderTab(activeTab)}
          </motion.div>
        </AnimatePresence>
      </div>
    </div>
  )
}

export default InfoPanel
